import { render, staticRenderFns } from "./CoverageQuixaForm.vue?vue&type=template&id=1a2ba063&scoped=true"
import script from "./CoverageQuixaForm.vue?vue&type=script&lang=js"
export * from "./CoverageQuixaForm.vue?vue&type=script&lang=js"
import style0 from "./CoverageQuixaForm.vue?vue&type=style&index=0&id=1a2ba063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ba063",
  null
  
)

export default component.exports